<template>
  <div class="content">
    <div class="con_bg"> 
      
      <div class="mainCon">
        <div class="main">
        <div class="line" v-for="(fitem, findex) in bookList" :key="findex">
          <!--标题 -->
          <div class="bgTit">
              <div class="titleName">{{fitem.typeName}}</div>
          </div> 
          <!-- 书单 -->
          <ul class="booklist" id="list">
            <li class="bookLi"    v-for="(item,index) in fitem.list" :key="index">
              <div class="bookLi1">
                <div class="bookImg"  >
                  <a @click="gotoDetail(fitem.resType,item)" target="_blank" :class="fitem.resType==1?'audio':''  ">
                    <img :src="item.cover" />
                  </a>
                </div>
                <div class="bookInfor">
                  <h3 class="bookName">
                    <a   @click="gotoDetail(fitem.resType,item)" target="_blank">{{item.name}}</a>
                  </h3>
                  <p class="author">{{item.author}}</p>
                  <p>
                    <a @click="gotoDetail(fitem.resType,item)" target="_blank" class="btn">{{fitem.resType==1?"立即播放":"立即阅读"}}</a>
                  </p>
                </div>
                <div class="intro">{{item.intro}}</div>
              </div>
              <!-- <div class="jianjie">内容简介</div>
              <div class="intro">{{item.intro}}</div>-->
            </li>
          </ul>
          <!-- 更多 -->
          <div class="more"  @click="goUrl(fitem.typeName,fitem.resType,fitem.groupId)" >查看更多>></div>
        </div>  
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { bookList } from "../../assets/js/data";
export default {
  name: "content",
  props: {
    routerPath: {
      type: String,
      default: ""
    }
  },
  data() {
    return {

    }
  },
  computed: {
    bookList() {
      return bookList;
    }
  },
  methods: {
    goUrl(name,restype,id) {
      //let postUrl = "//shuxiang.chineseall.cn/org/show/activity/book/mobile_characteristic_dz/0";
      let postUrl=window.location.origin+"/topic/list/mobile_characteristic_dz/0";
      if(restype && restype==1){//听书资源
          //postUrl = "//shuxiang.chineseall.cn/org/show/activity/audio/mobile_characteristic_dza/0";
        postUrl=window.location.origin+"/topic/list/mobile_characteristic_dza/1"
        } 
      let url =postUrl+"?topicGroup="+id+"&topicGroupName=" + encodeURI(name) + "&returnUrl="+this.routerPath; 
      //console.log("url:",url);
      window.location.href = url;
    },
    gotoDetail(ftype,item){
      if(item.overdue){
        this.open(item.name);
        return;
      } 
      if(ftype==1){
        window.open(item.pcUrl,"_blank");
      }else {
        window.open(item.url,"_blank"); 
      }
    },
    open(title) {
      this.$alert('本书授权到期，正在积极续签中。', title, {
        confirmButtonText: '好的',
        type: 'warning',
        customClass:'myalert-box-pc',
        // callback: action => {
        //   // this.$message({
        //   //   type: 'info',
        //   //   message: `action: ${ action }`
        //   // });
        // }
      });
    } 

  },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" >
.content {
  // width: 100%;
  // position: absolute;
  width: 100%;
  min-height: 2.9rem; 
  padding: 0 0;
  margin: 0 auto;
  position: relative;
  .con_bg {
    margin: 0 auto;
  }

  .bgTit {
    width: 100%;
    .titleName{
        display: inline-block;
        width: auto;
        height: 0.62rem;
        line-height: 0.62rem;
        padding: 0 0.52rem;
        font-size: 0.36rem;
        color: #ffde66;
        background-color: #dc2e15;
        border-radius: 0.4rem;  
        letter-spacing: 0.02rem;
        font-weight: bold;
    }
    img {
      width: 5.07rem;
    }
  }

  .htitle {
    margin-bottom: 0.25rem;
    img {
      width: 2.93rem;
    }
  }
  .info {
    margin-bottom: 0.3rem;
    img {
      width: 2.93rem;
    }
    .text{
          display: inline-block;
          text-align: left;
    }
    .dec {
      width: 100%;
      .prize {
        height: 2.14rem;
        margin-bottom: 0.26rem;
        img {
          width: 2.14rem;
          height: 2.14rem;
        }
      }

      p {
        margin-bottom: 0.2rem;
        // color: #de0027;
        font-size: 0.2rem;
      }
      .level {
        font-size: 0.22rem;
        font-weight: bold;
        color: #e10a30;
      }
      .name {
        color: #e10a30;
      }
      .sm {
        margin-bottom: 0.3rem;
        font-size: 0.16rem;
        color: #e10a30;
      }
      .activeDec {
        text-align: left;
        margin-bottom: 0.4rem;
        h3 {
          font-size: 0.28rem;
          margin-bottom: 0.2rem;
        }
        p {
          margin: 0;
          line-height: 0.4rem;
        }
        .bold {
          font-weight: bold;
          width: 1rem;
          display: inline-block;
        }
      }
    }
    .gobtn {
      display: inline-block;
      height: 0.64rem;
      margin-bottom: 0.4rem;
      img {
        width: 2.5rem;
        height: 0.64rem;
      }
    }
    .mark {
      padding: 0 0.3rem;
      line-height: 0.38rem;
      text-align: left;
      color: #de0027;
    }
  }
  .mainCon {
    width: 100%;
    margin: 0.28rem auto 0;
    font-size: 0.18rem; 
    color: #333333;
    line-height: 0.24rem;
    .main {
      width: 100%;
      height: auto;
      padding: 0.3rem;
      box-sizing: border-box;
    }
  }
  .booklist {
    // padding: 0.4rem 0.35rem;

    display: flex;
    flex-wrap: nowrap;
    justify-content: safe; 
    >li:nth-child(3n){
      margin-right: 0;
    }
    li {
      width: 32%; 
      box-sizing: border-box;
      padding: 0.24rem 0.24rem;
      border: 1px solid #cb0101;
      margin-top: 0.3rem;
      position: relative;
      margin-right: 3%;

      .bookLi1 {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: 0.3rem;
        position: relative;
      }
      
      .intro {
        height: auto;
        font-size: 0.2rem;
        max-height: 1.28rem;
        line-height: 0.32rem; 
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        line-clamp: 4;
        -webkit-box-orient: vertical;
        margin-top: 0.2rem;
        text-align: left;
      }
      .jianjie {
        color: #FFFFFF;
        text-align: left;
        font-size: 0.16rem;
        font-weight: bold;
        margin-bottom: 0.1rem;
      }
      .audio::after{
        content: "";
        width: 100%;
        height: 100%;
        background: url("../../assets/img/play.png")no-repeat center;
        background-size: 0.5rem 0.5rem;
        background-color: rgba(0, 0, 0, 0.05);
        position: absolute;
        left: 0;
        top: 0;
     }
      .bookImg {
        width: 1.54rem;
        height: 2.08rem;
        margin-right: 0.3rem;
        position: relative;
        a {
          display: inline-block;
          width: 100%;
          height: 100%;
          box-shadow: 0 0.03rem 0.05rem -0.01rem rgba(0, 0, 0, 0.2), 0 0.06rem 0.1rem 0 rgba(0, 0, 0, 0.14), 0 0.01rem 0.18rem 0 rgba(0, 0, 0, 0.12);
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
      .bookInfor {
        flex: 1;
        text-align: left;
        position: relative;
        a{
          color: #333333;
        }
        .bookName {
          font-size: 0.24rem;
          font-weight: bold;
          height: auto;
          max-height: 0.64rem;
          line-height: 0.32rem;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        
        }
        .author {
          font-size: 0.24rem;
          height: 0.32rem;
          line-height: 0.32rem;
          font-weight: 400;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          line-clamp: 1;
          -webkit-box-orient: vertical;
          margin-top: 0.2rem;
        }

        .btn {
          font-size: 0.18rem;
          display: inline-block;
          width: auto;
          height: 0.44rem;
          line-height: 0.44rem;
          padding: 0 0.15rem;
          background: #CB4127;
          border-radius: 0.08rem; 
          text-align: center;  
          color: #ffffff;
          margin-top: 0.15rem;
          letter-spacing: 0.02rem;
          position: absolute;
          left: 0;
          bottom: 0;
        }
      }
    }
  }
}
.more{
    width: 80%;
    height: 0.38rem;
    line-height: 0.38rem;
    margin: 0 auto;
    font-size: 0.32rem;
    color: #cb0101;
    text-align: center;
    margin-top: 0.5rem;
    cursor: pointer;
}
.line:first-child{
  margin-top: 0.2rem;
}
.line{
  margin-top: 1rem;
}
.el-message-box.myalert-box-pc {
  .el-message-box__title{
    padding-right: 20px;
  }
} 
</style>
